import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';

export const frontendURL = (path, params, root = false) => {
  const stringifiedParams = params ? `?${new URLSearchParams(params)}` : '';
  return !root ? `/app/${path}${stringifiedParams}` : `/${path}${stringifiedParams}`;
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

export const getLoginRedirectURL = ({
  ssoAccountId,
  ssoConversationId,
  user,
  embedding,
}) => {
  if (!user.accounts || user.accounts.length == 0) {
    return frontendURL(`user/profile`);
  }
  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    if (ssoConversationId) {
      let urlConversation = `${accountPath}/conversations/${ssoConversationId}`;
      urlConversation = embedding ? urlConversation += '?embedding=true' : urlConversation;
      return frontendURL(urlConversation);
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};

export const conversationUrl = ({
  accountId,
  activeInbox,
  id,
  label,
  productLabel,
  topicLabel,
  concurrentLabel,
  teamId,
  conversationType = '',
  foldersId,
}) => {
  let url = `accounts/${accountId}/conversations/${id}`;
  if (activeInbox) {
    url = `accounts/${accountId}/inbox/${activeInbox}/conversations/${id}`;
  } else if (label) {
    url = `accounts/${accountId}/label/${label}/conversations/${id}`;
  } else if (productLabel) {
    url = `accounts/${accountId}/product_label/${productLabel}/conversations/${id}`;
  } else if (topicLabel) {
    url = `accounts/${accountId}/topic_label/${topicLabel}/conversations/${id}`;
  } else if (concurrentLabel) {
    url = `accounts/${accountId}/concurrent_label/${concurrentLabel}/conversations/${id}`;
  } else if (teamId) {
    url = `accounts/${accountId}/team/${teamId}/conversations/${id}`;
  } else if (foldersId && foldersId !== 0) {
    url = `accounts/${accountId}/custom_view/${foldersId}/conversations/${id}`;
  } else if (conversationType === 'mention') {
    url = `accounts/${accountId}/mentions/conversations/${id}`;
  } else if (conversationType === 'participating') {
    url = `accounts/${accountId}/participating/conversations/${id}`;
  } else if (conversationType === 'unattended') {
    url = `accounts/${accountId}/unattended/conversations/${id}`;
  } else if (conversationType === 'unread') {
    url = `accounts/${accountId}/unread/conversations/${id}`;
  } else if (conversationType === 'lasted') {
    url = `accounts/${accountId}/lasted/conversations/${id}`;
  }

  return url;
};

export const conversationBoardUrl = ({
  accountId,
  activeInbox,
  id,
  label,
  teamId,
  conversationType = '',
  foldersId,
  boardSelected,
  status,
}) => {
  let url = `accounts/${accountId}/board-${boardSelected}/conversations/${id}`;
  if (activeInbox) {
    url = `accounts/${accountId}/board-${boardSelected}/inbox/${activeInbox}/conversations/${id}`;
  } else if (label) {
    url = `accounts/${accountId}/board-${boardSelected}/label/${label}/conversations/${id}`;
  } else if (teamId) {
    url = `accounts/${accountId}/board-${boardSelected}/team/${teamId}/conversations/${id}`;
  } else if (foldersId && foldersId !== 0) {
    url = `accounts/${accountId}/board-${boardSelected}/custom_view/${foldersId}/conversations/${id}`;
  } else if (status) {
    url = `accounts/${accountId}/board-${boardSelected}/status/${status}/conversations/${id}`;
  }
  return url;
};

export const conversationListPageURL = ({
  accountId,
  conversationType = '',
  inboxId,
  label,
  productLabel,
  topicLabel,
  concurrentLabel,
  teamId,
  customViewId,
}) => {
  let url = `accounts/${accountId}/dashboard`;
  if (label) {
    url = `accounts/${accountId}/label/${label}`;
  } else if (productLabel) {
    url = `accounts/${accountId}/product_label/${productLabel}`;
  } else if (topicLabel) {
    url = `accounts/${accountId}/topic_label/${topicLabel}`;
  } else if (concurrentLabel) {
    url = `accounts/${accountId}/concurrent_label/${concurrentLabel}`;
  } else if (teamId) {
    url = `accounts/${accountId}/team/${teamId}`;
  } else if (inboxId) {
    url = `accounts/${accountId}/inbox/${inboxId}`;
  } else if (customViewId) {
    url = `accounts/${accountId}/custom_view/${customViewId}`;
  } else if (conversationType) {
    const urlMap = {
      mention: 'mentions/conversations',
      unattended: 'unattended/conversations',
      unread: 'unread/conversations',
      last: 'lasted/conversations'
    };
    url = `accounts/${accountId}/${urlMap[conversationType]}`;
  }
  return frontendURL(url);
};

export const conversationBoardListPageURL = ({
  accountId,
  conversationType = '',
  inboxId,
  label,
  teamId,
  boardSelected,
  status,
}) => {
  let url = `accounts/${accountId}/board-${boardSelected}`;
  if (label) {
    url = `accounts/${accountId}/board-${boardSelected}/label/${label}`;
  } else if (teamId) {
    url = `accounts/${accountId}/board-${boardSelected}/team/${teamId}`;
  } else if (conversationType === 'mention') {
    url = `accounts/${accountId}/board-${boardSelected}/mentions/conversations`;
  } else if (inboxId) {
    url = `accounts/${accountId}/board-${boardSelected}/inbox/${inboxId}`;
  } else if (status) {
    url = `accounts/${accountId}/board-${boardSelected}/status/${status}`;
  }
  return frontendURL(url);
};

export const isValidURL = value => {
  /* eslint-disable no-useless-escape */
  const URL_REGEX = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm;
  return URL_REGEX.test(value);
};
